import PropTypes from 'prop-types';
import ArticleActionAnchor from '../articleActionAnchor';
import Icon from '../../icon';
import { createArticleLink } from '../../../utils/linkCreator';
import { trackAdobeEvent, NavigationClickEventDataPropTypes } from '../../../utils/trackers/adobe';

export default function ViewAtScopusAnchor({ eid, id, viewAtScopusEventData }) {
  const onClick = () => {
    trackAdobeEvent('navigationClick', viewAtScopusEventData);
  };

  return (
    <ArticleActionAnchor
      icon={<Icon.NavigateRight height={18} />}
      href={createArticleLink({ eid })}
      id={id}
      label="View at Scopus"
      onClick={onClick}
    />
  );
}

ViewAtScopusAnchor.propTypes = {
  eid: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  viewAtScopusEventData: PropTypes.shape(NavigationClickEventDataPropTypes).isRequired,
};
